import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from "@angular/core";
import {
  AVATAR_SEEDS,
  seedToUrl,
} from "../../../core/constants/avatars.constant";

@Component({
  selector: "app-avatar-picker",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./avatar-picker.component.html",
  styleUrl: "./avatar-picker.component.scss",
})
export class AvatarPickerComponent {
  readonly currentUrl = input<string | null>(null);
  readonly select = output<string>(); // emits the full avatar URL
  readonly cancel = output<void>();

  readonly selected = signal<string | null>(null);

  readonly avatars = AVATAR_SEEDS.map((seed) => ({
    seed,
    url: seedToUrl(seed),
  }));

  pick(url: string): void {
    this.selected.set(url);
  }

  confirm(): void {
    const url = this.selected() ?? this.currentUrl();
    if (url) this.select.emit(url);
  }

  isSelected(url: string): boolean {
    return (this.selected() ?? this.currentUrl()) === url;
  }
}
